import type { SVGProps } from 'react';
const DawnFlagBH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-BH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-BH_svg__a)">
      <path
        fill="#E7243B"
        fillRule="evenodd"
        d="M22 0H6.286l1.572 1.067-1.572 1.066L7.858 3.2 6.286 4.267l1.572 1.066L6.286 6.4l1.572 1.067-1.572 1.066L7.858 9.6l-1.572 1.067 1.572 1.066L6.286 12.8l1.572 1.067-1.572 1.066L7.858 16H22z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagBH;
